import { render, staticRenderFns } from "./Show4PMix.vue?vue&type=template&id=0685eb12"
import script from "./Show4PMix.vue?vue&type=script&lang=js"
export * from "./Show4PMix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports